import Header from "./Header";
import Footer from "./Footer";
import BookCard from "./BookCard";
import translatedHeading from "../utils/util";
import axios from "axios";
import _ from "lodash";
import * as localforage from "localforage";
import { useEffect, useState } from "react";
import "../styles/App.css";

const Publications = () => {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      let initialBooks = [];
      try {
        const cachedBooks = await localforage.getItem("books");
        if (isMounted && cachedBooks && Array.isArray(cachedBooks)) {
          initialBooks = cachedBooks;
          setBooks(cachedBooks);
        }
      } catch (error) {
        console.error("Error reading from localforage:", error);
      }

      try {
        const response = await axios.get(
          "https://brahmavidyalayaashram.in/server/api.php?endpoint=/publications"
        );

        if (
          isMounted &&
          response &&
          response.data &&
          Array.isArray(response.data)
        ) {
          if (!_.isEqual(initialBooks, response.data)) {
            setBooks(response.data);
            await localforage.setItem("books", response.data);
          }
        }
      } catch (error) {
        console.log("API fetch error:", error);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);
  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Publications")}</div>
      {books.length === 0 && <div className="loader"></div>}
      <div className="publications">
        {books &&
          books.length > 0 &&
          books.map((book) => <BookCard id={book.id} book={book} />)}
      </div>
      <Footer />
    </>
  );
};
export default Publications;
